import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateNotificationRequest, NotificationMessage, NotificationStatus, UpdateNotificationRequest } from '../../models';
import { HttpParamsEncoder } from '../../tools/query-params-encoder';
import { ApiService } from '../api.service';


@Injectable({
    providedIn: 'root',
})
export class MeddataNotificationService extends ApiService {

    getRecipient(recipient: string): Observable<NotificationMessage[]> {
        const params = new HttpParamsEncoder().encode({ recipient: recipient, status: NotificationStatus.Sent });
        return this.http.get<NotificationMessage[]>(`${this.notificationBaseUrl}/api/notification/recipient-notifications`, { params });
    }
    
    getNotifications(queryParams?: any): Observable<any> {
        const params = new HttpParamsEncoder().encode(queryParams);
        return this.http.get<any>(`${this.notificationBaseUrl}/api/notification`, { params });
    }

    create(model: CreateNotificationRequest): Observable<string> {
        return this.http.post<string>(`${this.notificationBaseUrl}/api/notification`, model);
    }

    update(model: UpdateNotificationRequest): Observable<string> {
        return this.http.put<string>(`${this.notificationBaseUrl}/api/notification`, model);
    }
}
